import { faCircleNotch, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons'
import { defineComponent, PropType } from 'vue'

import { Featured } from '@skinsoft/types'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import { EntityFeaturedCard, FeaturedCard } from '@skinsoft/ui'
import { DELETE_CARD } from '@skinsoft/events'
import { toFeatured$ } from '../../serializer/featured'

export const MovementFeaturedCard = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sEntityFeaturedCard: EntityFeaturedCard,
        sFeaturedCard: FeaturedCard,
    },
    template: require('./movement-featured-card.html'),
    props: {
        needsToFetchFeatured: {
            type: Boolean,
            default: true
        },
        featured: {
            type: Object as PropType<Featured>,
        }
    },
    data() {
        return {
            // $movementDataStore (used in the template) is a Vue.prototype global installed by
            // MovementDataStore's Vue.use(), not per-instance state, so it has no data field here
            serializer: toFeatured$,

            isBeingDeleted: false,
            deleting: false,

            checkIcon: faCheck,
            crossIcon: faTimes,
            circleNotchIcon: faCircleNotch,
        }
    },
    methods: {
        deleteMovement() {
            if(this.featured?.id) {
                this.deleting = true
                this.$emit(DELETE_CARD, this.featured.id)
            }
            else if(this.needsToFetchFeatured) {
                this.deleting = true
                this.$emit(DELETE_CARD)
            }
        },
    },
    watch: {
        featured() {
            this.isBeingDeleted = false
            this.deleting = false
        },
    },
})
